<template>
  <a-card>
    <div class="main-panel" style="height: 800px">
      <div class="main-title-wrap">
        <div style="text-align: right">
          <a-button style="" type="link" @click="add" v-has="'COMPANY_ADD'">
            添加
          </a-button>
          <a-dropdown trigger="click" v-has="'COMPANY_UP'">
                <span class="el-dropdown-link">
                <a-button type="link" icon="el-icon-upload2">导入导出</a-button>
              </span>
            <a-menu slot="overlay">
              <a-menu-item icon="el-icon-upload">
                <a-upload
                  action="/api/import-province"
                  @change="handleSuccess"
                  :before-upload="beforeAvatarUpload"
                  :showUploadList="false">
                  <span>上传文件</span>
                </a-upload>
              </a-menu-item>
              <a-menu-item icon="el-icon-download" @click="exportExcel">下载文件
              </a-menu-item>
              <a-menu-item icon="el-icon-document-copy" @click="downloadExcel">下载模板
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
      <div class="main-content-wrap">
        <a-row>
          <a-col :span="24">
            <a-table :loading="table.loading"
                     :data-source="table.data"
                     :default-sort="table.sort"
                     :pagination="table.pagination"
                     @change="handleTableChange"
                     ref="table.dataRef">
<!--              <a-table-column align="center" type="index" title="No." width="100" :index="table_index">-->
<!--              </a-table-column>-->
              <a-table-column align="center" data-index="province" title="省份" width="">
              </a-table-column>
              <a-table-column align="center" data-index="city.city" title="发货城市" width="">
              </a-table-column>
              <a-table-column align="center" data-index="area.name" title="所属区域" width="">
              </a-table-column>
              <a-table-column align="center" data-index="createAt" title="创建时间" width="">
              </a-table-column>
              <a-table-column align="center" data-index="updatedAt" title="更新时间" width="">
              </a-table-column>
              <a-table-column align="center" title="操作" width="350">
                <template slot-scope="text, record">
                  <a-button @click="edit(record)" type="link" v-has="'PROVINCE_EDIT'" size="small">编辑</a-button>
                  <span class="spanCss" v-has="'PROVINCE_DELETE'">|</span>
                  <a-button @click="del(record)" type="link" v-has="'PROVINCE_DELETE'" size="small"
                            class="operationBtn">删除
                  </a-button>
                </template>
              </a-table-column>
            </a-table>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-modal v-model="form.visible" width="600px" :destroy-on-close="true"  @cancel="onFormCancel" @ok="onFormSave">
      <province-edit :get-list="getList"  :province-id="form.data.provinceId" ref="provinceEditRef"></province-edit>
    </a-modal>

  </a-card>
</template>

<script>
import {getProvinceList, delProvince} from '../../../api/province';
import ProvinceEdit from './ProvinceEdit';
import {getTime} from '../../../utils/dateUtil';
import {transportTypeFormat} from '../../../utils/formatConvert';
import {delWarnReason} from "../../../api/warnReson";


/**
 * 初始化列表数据
 */
async function getList() {
  const result = await getProvinceList(this.table.pagination.current-1,this.table.pagination.pageSize);
  if (result.code === 1200) {
    this.table.data = result.data.provinces;
    this.table.pagination.total = result.data.totalCount;
  }
}

/**
 * 显示条目数
 * @param val
 */
function handleSizeChange(val) {
  this.listQuery.size = val;
  this.getList();
}

/**
 * 当前页
 * @param val
 */
function handleCurrentChange(val) {
  this.listQuery.page = val;
  this.getList();
}

/**
 * 列表排列的序号
 * @param index
 * @returns {*}
 */
function table_index(index) {
  return (this.listQuery.page - 1) * this.listQuery.size + index + 1;
}

function onFormSave() {
  this.form.visible = false;
  this.$refs.provinceEditRef.save();
  // this.getList();
  this.form.data = {};
}


function onFormCancel() {
  this.form.visible = false;
  this.getList();
  this.form.data = {};
}

function edit(record) {
  this.form.data.provinceId = record.id;
  this.form.visible = true;
}

function add() {
  this.form.data.provinceId = '';
  this.form.visible = true;
}

function del(record) {
  let that = this;
  this.$confirm({
    title: '是否删除这条数据?',
    content: '',
    okType: 'danger',
    async onOk() {
      const result = await delProvince(record.id);
      if (result.code === 1200) {
        that.$message.success('删除成功')
        that.form.data = {};
        that.table.pagination.current=1
        await that.getList();
      }
    },
    //   this.onCancel()
    onCancel() {
    },
    class:
      'test',
  });
}

function addRole(id) {
  this.form.data.provinceId = id;
  this.form.visible = false;
}

/**
 * 文件上传之前的回调函数
 */
// eslint-disable-next-line consistent-return
function beforeAvatarUpload(file) {
//        判断上传文件的后缀 是否为 xls 或 xlsx 格式
  const index = file.name.lastIndexOf('.');
  const fileName = file.name.substring(index + 1);
  if (fileName !== 'xls' && fileName !== 'xlsx') {
    let that = this;
    this.$confirm({
      title: '上传文件必须为 .xls 或 .xlsx 格式 ?',
      content: '',
      okType: 'warning',
      onOk() {
        that.form.dialogVisibleWorker = false;
      },
      //   this.onCancel()
      onCancel() {
        that.form.dialogVisibleWorker = false;
      },
      class:
        'test',
    });
    // this.$confirm('上传文件必须为 .xls 或 .xlsx 格式 ', '提示', {
    //   confirmButtonText: '确定',
    //   cancelButtonText: '取消',
    //   type: 'warning',
    // }).catch(() => {
    //   //                关闭批量上传弹窗
    //   this.form.dialogVisibleWorker = false;
    // });
    return false;
  }
}

function handleSuccess(res) {
  let that = this;
  // setTimeout(() => {
    if(this.uploadTrue){
      if (res.file.response && res.file.response.code === 1200) {
        that.$message.success('上传成功');
        this.getList();
      }
    } else {
      this.uploadTrue = !this.uploadTrue
    }

  // }, 1000)
  // let that = this
  // if (res.code === 1200) {
  //   const h = this.$createElement;
  //   const msg = [];
  //   // eslint-disable-next-line guard-for-in,no-restricted-syntax
  //   for (const key in res.data.map) {
  //     msg.push(h('p', key));
  //   }
  //   if (msg.length > 0) {
  //     let that = this;
  //     this.$confirm({
  //       title: h('div', msg),
  //       content: '',
  //       okType: 'warning',
  //       onOk() {
  //         // that.$message.success('上传成功');
  //       },
  //       //   this.onCancel()
  //       onCancel() {
  //         // that.form.dialogVisibleWorker = false;
  //       },
  //       class:
  //         'test',
  //     });
  //     // this.$confirm(h('div', msg), '提示', {
  //     //   type: 'warning',
  //     //   confirmButtonText: '确认',
  //     //   cancelButtonText: '取消',
  //     // });
  //   } else {
  //     that.$message.success('上传成功');
  //   }
  //   // if (msg.length > 0) {
  //   //   this.$confirm(h('div', msg), '提示', {
  //   //     type: 'warning',
  //   //     confirmButtonText: '确认',
  //   //     cancelButtonText: '取消',
  //   //   });
  //   // } else {
  //   //   this.$message({
  //   //     message: '上传成功',
  //   //     type: 'success',
  //   //   });
  //   // }
  //   this.getList();
  // }
}

async function downloadExcel() {
  this.$confirm({
    title: '是否下载省份配置导入模板.xlsx？',
    content: '',
    okType: 'warning',
    onOk() {
      window.location.href = '/api/signForImg/省份配置导入模板.xlsx';
      // that.$message.success('上传成功');
    },
    //   this.onCancel()
    onCancel() {
      // that.form.dialogVisibleWorker = false;
    },
    class:
      'test',
  });

  // this.$confirm('是否下载省份配置导入模板.xlsx？', '提示', {
  //   type: 'warning',
  //   confirmButtonText: '确认',
  //   cancelButtonText: '取消',
  // }).then(async () => {
  //   // window.location.href = "http://localhost:8099/signForImg/导入运费和计费重量模板.xlsx";
  //   window.location.href = '/api/signForImg/省份配置导入模板.xlsx';
  // });
}

async function exportExcel() {
  const result = await getProvinceList(0, 9999);
  if (result.code === 1200) {
    const data = result.data.provinces.map(x => ({
      ...x,
      cityStr: x.city.city,
      areaStr: x.area.name,
    }));
    this.excelData = result.data.provinces;
    const tHeader = ['省份', '发货城市', '所属区域'];
    // 上面设置Excel的表格第一行的标题
    const filterVal = ['province', 'cityStr', 'areaStr'];
    // 上面的index、nickName、name是tableData里对象的属性
    this.exportData(data, tHeader, filterVal, `省份配置导出${ getTime() }`);
  }
}


function exportData(excelData, tHeader, filterVal, name) {
  const that = this;
  require.ensure([], () => {
    // eslint-disable-next-line camelcase,global-require
    const { export_json_to_excel } = require('../../../utils/Export2Excel');
    // 上面设置Excel的表格第一行的标题
    // 上面的index、nickName、name是tableData里对象的属性
    const data = that.formatJson(filterVal, excelData);
    export_json_to_excel(tHeader, data, name + getTime());
  });
}

// eslint-disable-next-line no-unused-vars
function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getList();
}

export default {
  components: {
    ProvinceEdit,
  },
  methods: {
    getList,
    handleSizeChange,
    handleCurrentChange,
    table_index,
    onFormSave,
    onFormCancel,
    edit,
    add,
    del,
    addRole,
    beforeAvatarUpload,
    handleSuccess,
    downloadExcel,
    exportExcel,
    exportData,
    formatJson,
    handleTableChange,
  },
  async created() {
    this.getList();
    this.excelName = `省份配置导出${ getTime() }.xls`;
  },
  data() {
    return {
      excelName: '',
      json_fields: {
        省份: 'province', // 常规字段
        所属区域: 'area.name', // 支持嵌套属性
      },
      excelData: [],
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
      },
      form: {
        visible: false,
        data: {
          provinceId: '',
        },
      },
    };
  },
};
</script>
